<template>
  <div>
    <b-alert :variant="message.type" :show="dismissCountDown" dismissible @dismissed="dismissCountDown = 0"
      @dismiss-count-down="countDownChanged">
      <label style="white-space: pre-wrap;" class="m-0">{{ message.message }}</label>
      <router-link v-if="message.link" :to="message.link">Follow link</router-link>
    </b-alert>
  </div>
</template>

<script>
export default {
  props: ['message'],
  data() {
    return {
      dismissCountDown: 0,
    }
  },
  watch: {
    message: function () {
      window.scrollTo(0, 0);
      this.dismissCountDown = 7;
    }
  },
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
  },
};
</script>
